module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-04@2x.3c9bc9bf.jpg";